import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/api/axios-instance";

/** GET /health of the backend: its build (backend src/build_info.py). Older builds answer `{status}` only. */
export interface BackendBuild {
  status?: string;
  version?: string | null;
  git_sha?: string | null;
}

/** The build of the backend the admin talks to; refreshed every few minutes, so a deploy shows without a reload. */
export function useBackendVersion() {
  return useQuery({
    queryKey: ["backend-version"],
    queryFn: async ({ signal }) => {
      const { data } = await axiosInstance.get<BackendBuild>("/health", { signal });
      return data;
    },
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
    retry: 1,
  });
}
